export default {
  AccountPage: {
    address: 'Address',
    biometricLogin: {
      android: 'Login with biometry',
      default: 'Login with biometry',
      ios: 'Login with biometry or passcode'
    },
    biometricLoginDisabled: 'Biometric login disabled',
    biometricLoginEnabled: 'Biometric login enabled',
    birthDate: 'Birth Date',
    customerReferenceNumber: 'Customer reference number',
    email: 'Email',
    gender: {
      FEMALE: 'Female',
      MALE: 'Male',
      title: 'Gender'
    },
    generalInformation: 'General Information',
    language: 'Preferred Language',
    lastName: 'Last name',
    loansHistory: 'Your loans history',
    logout: 'Log out',
    middleName: 'Patronymic',
    name: 'Name',
    phone: 'Phone',
    pin: 'Personal identification number',
    title: 'My Account',
    updatePhoneNumber: 'Update your phone number'
  },
  BankTransferDisclaimerPage: {
    subtitle: 'Please visit our nearest branch so personal identification and account approval process may be completed.',
    title: 'Bank transfer'
  },
  Banner: {
    footnote: '* To enjoy fully, new features of MyIute Self-service, you need to log in with your Personal Identification Code (PIN).',
    item: {
      1: 'Apply for loans and manage them online 24/7',
      2: 'Receive personalized offers',
      3: 'Pay installments without leaving your home'
    },
    title: 'Manage your loans on the go with improved MyIute self service'
  },
  BiometricLoginError: {
    action: 'Go to phone settings',
    close: 'Not right now',
    title: "Can't enable biometry, please check your phone settings"
  },
  BiometricLoginPrompt: {
    close: 'Not right now',
    enable: 'Enable',
    title: {
      android: 'Would you like to ease the login process by enabling fingerprint/facial recognition? 😊',
      default: 'Would you like to enable biometric login?',
      ios: 'Would you like to ease the login process by enabling fingerprint/facial recognition or using your PIN ? 😊'
    }
  },
  BottomNav: {
    contact: 'Contact',
    loans: 'Loans',
    locations: 'Locations',
    mainSiteName: 'iutecredit.ba',
    mainSiteUrl: 'https://iutecredit.ba',
    mastercard: 'Card',
    my: 'MyIute',
    overview: 'Overview'
  },
  BranchDetailsPage: {
    businessHours: 'Opening time',
    cashWithdrawal: 'Cash withdrawal',
    email: 'E-mail',
    phone: 'Phone',
    viewOnMap: 'View on map'
  },
  BranchSelectionPage: {
    description: 'Your Mastercard is ready at any branch',
    title: 'Select Iute branch'
  },
  BranchesPage: {
    title: 'Branches'
  },
  CardAgreementSignedSuccessPage: {
    description: 'Your card is on its way. You will be contacted on the phone by the courier for time of delivery.',
    done: 'Done',
    title: 'Mastercard agreement signed'
  },
  CardContractSendPage: {
    cardTitle: 'Review the Mastercard contract',
    downloadDescription: 'You can also download the Mastercard contract'
  },
  CardCourierPage: {
    addNewAddress: 'Add new',
    apartment: 'Apartment',
    back: 'Back',
    cancel: 'Cancel',
    city: 'City',
    cityDistrict: 'City district',
    confirm: 'Confirm and order',
    enterAnotherAddress: 'Enter new address',
    houseNumber: 'House number',
    phone: 'Phone',
    pickAnotherAddress: 'Select other address',
    query: 'Search address',
    street: 'Street',
    title: 'Delivery details',
    zipCode: 'Zip code'
  },
  CardDeliverySelectionPage: {
    byCourier: 'Courier delivery',
    byCourierInfo: 'Will be delivered in 24 hours after card is ordered except Sunday',
    recommended: 'Recommended',
    subtitle: 'Choose a method to receive your new Mastercard',
    title: 'Get Mastercard',
    toBranch: 'Pick card from Iute branch',
    toBranchInfo: 'Find closest branch, card available immediately'
  },
  CardOrderConfirmationPage: {
    confirm: 'Confirm and order'
  },
  CardOrderSuccessPage: {
    address: 'Address',
    descriptionForBranch: 'Your choice for {branch} is taken, but you can still go and pick up the card at any of our branches 😊',
    descriptionForCourier: 'Your Mastercard order is taken, we will ask you to sign the Mastercard agreement before sending your card. Please stay tuned with us.',
    done: 'Done',
    title: 'Mastercard ordered'
  },
  CardPayoutSuccess: {
    description: 'Please check your Mastercard balance',
    done: 'Done',
    title: 'Your request is processed'
  },
  CashPalBanner: {
    applyNow: 'Apply now',
    body: 'Applying only takes 30 seconds',
    getAmount: '{name}, you can get your {amount} pre-approved loan limit right away!',
    title: 'Get money immediately!'
  },
  ConsentDocumentPage: {
    disclaimerFooter: 'In case of any disputes between the languages, Bulgarian version shall prevail',
    disclaimerHeader: 'English version after Bulgarian version',
    disclaimerSpecimen: 'English Specimen – for informational purposes only'
  },
  Contacts: {
    branches: 'Branch office locations',
    businessHours: 'Our customer service is available in the following terms: MON-FRI 08:00 – 19:00, SAT-SUN 09:00 – 17:00',
    callUs: 'Call us',
    chat: 'Chat now',
    email: 'E-mail',
    facebook: 'Facebook',
    findUs: 'Find us',
    followUs: 'Follow us',
    instagram: 'Instagram',
    internet: 'Website',
    linkedin: 'LinkedIn',
    mastercard: 'Mastercard <br/>(card blocking)',
    partners: 'Our partners',
    title: 'Contact us',
    viber: 'Viber',
    whatsapp: 'WhatsApp',
    youtube: 'Youtube'
  },
  ContractSendPage: {
    cardTitle: 'Review the contract',
    download: 'Download',
    downloadDescription: 'You can also download the contract',
    email: 'Email',
    placeholder: 'Your e-mail',
    sendButton: 'Send to e-mail',
    text: 'Send the contract to your e-mail for reviewing.',
    title: 'View the contract',
    wasSent: {
      message: 'Your contract is now sent to the e-mail provided',
      title: 'Success'
    }
  },
  CreditLimit: {
    message: 'You now have a credit limit for <strong>{amount}</strong>. Apply now via offers below for instant loan approval!',
    title: 'Congratulations!'
  },
  CustomerOverviewPage: {
    customerReferenceNumber: 'Customer reference number',
    noOffers: 'We do not have any offers available for you.',
    title: 'MyIute',
    toApp: 'Go back to mobile application'
  },
  DatePicker: {
    day: 'Day',
    month: 'Month',
    placeholders: {
      day: 'DD',
      month: 'MM',
      year: 'YYYY'
    },
    year: 'Year'
  },
  ExternalPaymentsPage: {
    description: 'Choose the most convenient method to make a repayment.',
    other: 'Other options',
    recommended: 'Recommended',
    title: 'Payment options'
  },
  GeneralTermsPage: {
    title: 'General Terms'
  },
  HomePage: {
    applyForALoan: 'Apply for a loan',
    login: 'Log in',
    selectLanguage: 'Select language'
  },
  LoanAgreement: {
    actionPrivacyPolicy: 'Privacy Policy',
    agreeAndSubmit: 'Agree and submit',
    apr: 'APR',
    autoAgreement: {
      BASIC: 'By continuing you confirm that you have read Personal Data Processing Notification, Terms and agree with the conditions listed above.',
      COMFORT: 'By continuing you confirm that you have read Personal Data Processing Notification, Pre-contract, Terms and agree with the conditions listed above.'
    },
    campaignMonthlyPayments: 'Monthly repayment if you sign in MyIute app',
    consent: 'Consent',
    creditRegistryConsent: 'I hereby give my {action} to MKD IuteCredit BH d.o.o. Sarajevo to check my credit history based on the information stored in the database in the Central Credit Register of B&H and use the received data to assess my creditworthiness.',
    eir: 'EIR',
    fees: 'Fees',
    loanAmount: 'Loan amount',
    loanBalance: 'Amount to be refinanced',
    loanNumber: 'Loan reference number',
    loanPeriod: 'Loan period',
    month: '{count} month | {count} months',
    monthlyPayments: 'Monthly Payments',
    newsAgreement: 'I would like to receive exclusive offers via SMS or E-mail',
    newsAgreementLink: 'Read more',
    notice: 'Before applying for a loan we advise you to consider your financial possibilities and submit exact and relevant information about your financial situation.',
    pep: 'I declare that I am not a Politically Exposed Person (PEP). {action}',
    pepConsentLink: 'Read more',
    personalDataProcessingConsent: 'I am informed and agree with the personal data processing principles as described in the {action}',
    preContract: 'Pre-contract',
    refinanceableAmount: 'Amount to be refinanced',
    refinanceDisclaimer: 'The loan/s below will be closed by signing the new contract and you will have only one loan in amount of {loanAmount}',
    requestedAmount: 'Requested loan amount',
    title: 'Review the terms',
    totalPayment: 'Total Payment',
    totalAmount: 'Final loan amount'
  },
  LoanApplicationCard: {
    extraCash: 'Extra cash',
    yourApplication: 'Your loan application'
  },
  LoanApplicationDetailsPage: {
    reference: 'Reference #{reference}',
    title: 'Loan application'
  },
  LoanApplicationThankYouPage: {
    close: 'Back to using app',
    title: 'You have successfully applied for a loan!<br/>Thank you!'
  },
  LoanApplicationTimeline: {
    addDocumentPhotos: 'Add document photos',
    addMoreDocuments: 'Add more',
    alternativeDealerSigningPlaces: 'Alternatively, you may sign your contact at our partner',
    alternativeRegularSigningPlaces: 'Alternatively, you may sign your contract at any of the {signingBranches}',
    amount: 'Amount',
    applicationApproved: 'Application approved',
    applicationRejected: 'Application rejected',
    choosePayoutMethod: 'Choose payout method',
    continueToSigning: 'Continue to signing',
    contractSigned: 'Contract signed',
    dealerLoanIsSigned: 'You now have your product. Congrats!!',
    decision: 'Decision',
    documentPhotosAdded: '{count} document photo added | {count} document photos added',
    findSigningLocations: 'Find signing locations',
    loanPaidOut: 'Loan paid out',
    month: '{count} month | {count} months',
    ncAddressMissing: 'One small step is left to finalize your loan signing, please contact us at 0700 40 111 😊',
    ncDocumentsMissing: 'You will be contacted for further information to proceed with your application',
    offeredAmount: 'Offered amount',
    offeredPeriod: 'Offered period',
    payoutAmount: 'Payout amount',
    payoutLocations: 'See payout locations',
    payoutMethod: {
      abi: 'All set. You can now receive your cash at Pošta Srpske',
      atm: 'All set. You can now receive your cash at IuteCredit ATM.',
      bank: 'All set. You can now receive your cash on your bank account',
      bpay: 'All set. You can now receive your cash at Bpay ATM',
      card: 'All set. You can now receive your cash on every ATM in the country and abroad',
      cash_distribution: 'All set. You can now receive your cash at bank',
      easy_pay: 'All set. You can now receive your cash at EasyPay',
      paynet: 'All set. You can now receive your cash at Paynet operator',
      posta: 'All set. You can now receive your cash at BH Pošta',
      raefaes: 'All set. You can now receive your cash at any RAEAFS office',
      refinanced: 'Your loan is refinanced',
      restructured: '',
      victoria_bank: 'All set. You can now receive your cash at bank',
      western_union: 'All set. You can now receive your cash at any Western Union office'
    },
    period: 'Period',
    reason: 'Reason',
    receiveContract: 'Receive the contract',
    referenceNumber: 'Reference number',
    refinanceableAmount: 'Amount to be refinanced',
    rejectionReason: {
      REJECTED: 'Unfortunately, we cannot accept your application at the moment. Please visit us in the future.',
      WITHDRAWN: 'We are sorry that your application is withdrawn. If you would like to apply again, please apply on the app or contact us through Call Center or visit us in the branches'
    },
    signWithPhone: 'Sign using your phone, it only takes a moment.',
    signingBranches: 'IuteCredit branches.',
    signingLocation: {
      abi: 'You may sign your contract at any post office',
      call: 'You may sign your contract by calling at +355 44505060',
      dealer: 'You may sign your contract at dealer shop.',
      easy_pay: 'You may sign your contract at EasyPay',
      office: 'You may sign your contract at any of the IuteCredit branches.',
      online: 'You may sign your contract via Sms.',
      posta: 'You may sign your contract at any post office',
      raefaes: 'You may sign your contract at the Raeafs',
      shop: 'You may sign your contract at any of the IuteCredit partners. Please contact us at +355 44505060, for further information.',
      sms: 'You may sign your contract via Sms.',
      western_union: 'You may sign your contract at the Western Union'
    },
    status: {
      APPROVED: 'Signing',
      COMPLETED: 'Loan details will appear soon',
      REJECTED: 'Application rejected',
      REVIEW: 'Application review',
      SIGNED: 'Collect cash',
      SUBMIT: 'Application received',
      VERIFICATION: 'Identity verification',
      WITHDRAWN: 'Application withdrawn'
    },
    submitted: 'Submitted',
    uploadPhotosOfIdCard: 'To expedite the loan approval process, please upload your ID card.',
    verificationFailed: "We can't verify your identity, please, visit our branch 😒",
    verificationFailedForDealer: "We can't verify your identity 😒 You will be contacted by our partner to continue with the identification and signing",
    verificationFindLocations: 'Find locations',
    verificationIsDone: 'You are verified 😀',
    verificationIsInProgress: 'Your verification is in progress. Please check back within few minutes 😊',
    verificationIsNotSupported: 'Please update the mobile application or find a branch near you to identify yourself',
    verificationIsNotSupportedInDesktop: 'Please download the app to proceed with verification of yourself and signing of your loan',
    verificationShouldTakeShortTime: 'This should take only a couple of minutes',
    verificationStart: 'Start verification',
    verificationTitle: 'Please allow us to verify your identity for signing the contract.',
    youCanNowChoosePayoutMethod: 'You can now choose how you would like to retrieve the loan amount',
    youMayBeContacted: 'You will be contacted for further information to proceed with your application.',
    yourLoanIsRestructured: 'Your loan is restructured',
    youWillReceive: 'Amount to be received'
  },
  LoanCard: {
    closeDate: 'Loan end date',
    extraCash: 'Extra cash',
    finalDueAmount: 'Final due amount',
    loanAmount: 'Loan amount',
    nextPaymentDays: 'Today | Tomorrow | Next payment in {count} days',
    overdueDays: '{count} day overdue | {count} days overdue',
    payNow: 'Pay now',
    reference: 'Reference',
    remaining: 'Remaining',
    repayNow: 'Repay now',
    startDate: 'Loan start date'
  },
  LoanClosureConfirmationPage: {
    loanEndDate: 'Loan end date',
    reference: 'Reference number',
    title: 'Closure confirmation'
  },
  LoanDefaultedMessage: {
    REGULAR: {
      description: 'You may pay here or contact us at +387 33 257 666 or +387 51 981 330 to make an agreement regarding the payment of the loan.',
      title: 'Your Agreement of the microcredit has been terminated for delay in repayment of more than two installments.'
    },
    RESTRUCTURED: {
      description: '',
      title: 'Your loan has been restructured.'
    },
    WRITTEN_OFF: {
      description: 'You may pay here or contact us at +387 33 257 666 or +387 51 981 330 to make an agreement regarding the payment of the loan.',
      title: 'Your Agreement of the microcredit has been terminated for delay in repayment of more than two installments.'
    }
  },
  LoanDetailsPage: {
    apr: 'APR',
    closureCertificate: 'Get a loan closure confirmation',
    contract: 'Receive the contract',
    documents: 'Documents',
    fees: 'Fees',
    finalDueAmount: 'Final due amount',
    interestRate: 'Effective interest rate',
    loanAmount: 'Loan amount',
    loanEnd: 'Loan end',
    loanPeriod: 'Loan period',
    loanRepayEarlier: 'Pay Loan Early',
    loanStart: 'Loan start',
    month: '{count} month | {count} months',
    nextPayment: 'Next payment',
    nextPaymentDays: 'Today | Tomorrow | in {count} days',
    overdueDays: '{count} day overdue | {count} days overdue',
    paidAmount: 'Paid amount',
    payNow: 'Pay now',
    paymentSchedule: 'Repayment schedule',
    payoutMethod: 'Payout method',
    payoutMethods: {
      abi: 'Posta RS',
      atm: 'ATM',
      bank: 'Bank',
      bcr: 'Banca Comerciala Română Chişinău S.A.',
      bkt: 'Banka Kombetare Tregtare (BKT)',
      bpay: 'Bpay',
      card: 'Card',
      commert: 'BC COMERŢBANK S.A.',
      credins: 'Credins Bank',
      crm_refin: 'Loan refinancing',
      crm_restructured: 'Loan restructuring',
      dealer: 'Dealer partner',
      easy_pay: 'Easy Pay',
      eurocredit: 'BC EuroCreditBank S.A.',
      exim: 'BC Eximbank S.A.',
      intesa: 'Intesa San Paolo Bank',
      moldindcon: 'BC Moldindconbank S.A.',
      moldindcon_bank: 'BC Moldindconbank S.A.',
      paynet: 'Paynet',
      posta: 'Posta BH',
      qiwi: 'Qiwi',
      raefaes: 'RAEFS',
      raiffeisen: 'Raiffeisen Bank',
      refinanced: 'Refinanced',
      restructured: 'Restructured',
      runpay: 'RunPay',
      victoria: 'BC Victoribank S.A.',
      victoria_bank: 'BC Victoribank S.A.',
      western_union: 'Western Union'
    },
    referenceNo: 'Reference {referenceNo}',
    remainingBalance: 'Remaining balance',
    repayNow: 'Repay now',
    suspendInstallment: 'Suspend installment',
    title: 'Loan details',
    toBePaid: 'To be paid',
    whatIfLatePayment: 'What are the rates if I pay late?'
  },
  LoanFormPage: {
    accessFeeDisclaimer: '<strong>Access fee of {amount}</strong> is part of total fees and it will be deducted in advance from the pay out amount',
    apply: 'Apply now!',
    applyPal: 'Apply now and get instant approval!',
    apr: 'APR',
    campaignConditionsNC: 'Loan conditions displayed below is our discounted offer and is only valid for customers signing their agreements on MyIute',
    campaignConditionsNewCustomer: 'Monthly repayment if you sign in MyIute app',
    campaignConditionsReturningCustomer: 'Monthly repayment if you sign in MyIute app',
    campaignDiscount: 'Sign loan agreement digitally, save trees and receive discount of ',
    discountedMonthlyPayments: 'Discounted monthly repayment',
    eir: 'EIR',
    forMonths: 'For {count} | For {count} months',
    interestRate: 'Effective Interest Rate (EIR)',
    loanAmount: 'Loan amount',
    loanDisclaimer: 'The monthly installment and duration of the loan are displayed for demonstration purposes. After submission of your loan application, our credit experts will contact you to customize your loan needs to finalize the process. Familiarize yourself with the {tc}.',
    loanPeriod: 'Loan period',
    loanRepaymentDay: 'Loan repayment day',
    month: '{count} month | {count} months',
    monthlyPaymentDisclaimer: 'Monthly repayment shown above and fee total below take into account your other active loan/s. In the case of loan approval, all loans will be merged into one.',
    monthlyPaymentsFrom: 'Monthly repayments from',
    palLoanActive: 'You will get this amount instantly!',
    returningCustomerNotice: 'As a valuable customer, you are entitled to get better terms and conditions. We value our relationship',
    signYourself: 'Less paper, greener nature.',
    termsAndConditions: 'Terms & Conditions',
    title: 'Apply for a loan',
    totalFees: 'Fee total',
    upTo: 'Up to {count}',
    zeroCostFor30Days: '0% cost for 30 days'
  },
  LoanFullRepaymentPage: {
    adminFee: 'Admin fee',
    disclaimerFooter: 'Clicking on the button does not bring you additional liabilities. If the amount is not paid on the day mentioned above, loan instalments will continue as they are.',
    disclaimerHeader: 'Unless button is pressed, the amount shown above will not be saved. To proceed with early repayment process, please click on the button above.',
    guaranteeFee: 'Guarantee fee',
    interest: 'Interest',
    message1: 'Ready to repay the whole loan all together? Early repayment has its rewards!',
    message2: 'If you would repay everything on {date}, please see total amount to be paid below:',
    newRemainingBalance: 'Total amount to be paid',
    payLoanNow: 'Pay loan now',
    pendingRepayment: 'You already have pending loan full repayment initiated. You have time to pay {amount} until {date}',
    remainingBalance: 'Remaining balance',
    title: 'Repay Loan Early',
    youWillPayMore: 'You will pay additionally (unfortunately, no rewards this time ☹)',
    yourTotalSavings: 'Your total savings'
  },
  LoanOverdueMessage: {
    paymentIsOverdue: 'Your payment is overdue.<br>Please pay immediately!'
  },
  LoanPaymentCalculatorPage: {
    anErrorHappened: 'An error happened during calculation. Please, try again later',
    lateMessage: 'Your payments are overdue. Please make a payment of <strong>{amount}</strong>.',
    latePaymentMessage: 'On this day you would need to pay:',
    onTime: 'On time {date}',
    onTimeMessage: "We don't apply any fees if you pay on time. We expect you to pay <strong>{amount}</strong>.",
    primaries: 'Fees',
    principal: 'Principal',
    secondaries: 'Penalties',
    title: 'Calculate next payment amount',
    totalDept: 'Next payment amount',
    whenDoYouWantToPay: 'When do you want to pay?'
  },
  LoanPaymentSchedulePage: {
    currentDebt: 'Current debt',
    delayInterest: 'Delay interest: {delayInterest}',
    nextPaymentAmount: 'Next payment amount',
    nextPaymentDate: 'Next payment date',
    nextRepaymentAmount: 'Next repayment amount',
    paymentOverdue: 'Payment overdue',
    payments: 'No of installments / No of paid installment',
    paymentsNC: 'No of paid installments / No of installments',
    paymentsSchedule: 'Repayment schedule',
    penalties: 'Penalties {penaltiesAmount}',
    referenceNumber: 'Reference number',
    remainingBalance: 'Remaining balance',
    repaymentDate: 'Repayment date',
    sendToEmail: 'Send to email',
    showInstallments: 'Show installments',
    suspendInstallment: 'Suspend installment',
    suspendedUntil: 'Suspended until {suspendedUntil}',
    suspensionFee: 'Suspension fee {suspensionFee}',
    totalPaid: 'Total paid {paidAmount}',
    totalToBePaid: 'Total to be paid',
    totalUnpaid: 'To be paid {unpaidAmount}'
  },
  LoanRequestSuspensionPage: {
    newPaymentDate: 'New payment date',
    paymentAmount: 'Payment amount',
    paymentDate: 'Payment date',
    requestSuspension: 'Request suspension',
    suspensionFee: 'Suspension fee',
    suspensionNotAvailable: 'Suspension is not possible at this moment. Please contact our Call Center if you need further information.',
    suspensionNotice: 'We understand that there may be times where you cannot make your payments on time. We are here for you and offer the possibility to extend your repayment.\n\n Please carefully review suspension request details below before submitting your request.\n\nIn the case of non-payment on due date, penalties will be applied.',
    title: 'Suspend installment'
  },
  LoanStepContactsPage: {
    alreadyHaveALoanWithUs: '<strong>Already have a loan with us?</strong>',
    birthDate: 'Birth Date {birthDate}',
    continueBtn: 'Continue...',
    email: 'E-mail',
    firstName: 'First name',
    lastName: 'Last name',
    logIn: 'Log in',
    middleName: 'Patronymic name',
    personalCode: 'Personal Code',
    phone: 'Phone',
    phoneHint: 'Should start with 06 and be 9 or 10 digits long',
    title: 'Personal information'
  },
  LoanTerms: {
    personalDataProcessing: 'Personal Data Processing Notification',
    termsAndConditions: 'Terms'
  },
  LoanUnpaidMessage: {
    paymentIsUnpaid: 'Immediately due'
  },
  LoansPage: {
    status: {
      CLOSED: 'Closed',
      DEFAULTED: 'Defaulted loans',
      DELAYED: 'Delayed',
      NORMAL: 'Normal',
      PENDING: 'Pending',
      REFUNDED: 'Refunded',
      REJECTED: 'Rejected',
      WITHDRAWN: 'Withdrawn'
    },
    title: 'My loans'
  },
  LocationsPage: {
    branches: 'Branches',
    partners: 'Our partners'
  },
  LoginOtpPage: {
    anyOfOurBranches: 'any of our branches',
    phoneNumberNotValidPleaseVisit: 'If the phone number above is not valid, please visit'
  },
  LoginOtpReturningCustomer: {
    hasOffer: {
      message: 'We are letting you in to enjoy the benefits of your offers.',
      title: 'It seems like you have an account with us&nbsp;😀'
    },
    ncReturningCustomer: {
      message: 'Please enter OTP to access MyIute&nbsp;😀',
      title: 'It seems that you have an account with us'
    },
    withUsedOffer: {
      message: 'We are directing you to your account',
      title: 'You have an account with us'
    }
  },
  LoginPage: {
    fallbackLinkTitle: 'Apply for a loan',
    fallbackMessage: "Don't have an account? {fallbackLink} to get one.",
    logIn: 'Log in',
    messageForExistingCustomer: 'Already done business with us? Please log-in using your personal identification number.',
    pin: 'Personal identification number',
    title: 'Log in'
  },
  MaintenancePage: {
    title: 'MyIute is under maintenance. Please visit us soon.'
  },
  MastercardPage: {
    noRecentTransactions: 'No transactions in the last 30 days',
    title: 'Mastercard',
    validThru: 'Valid thru',
    yourLoanBalance: 'Your card balance'
  },
  Offer: {
    applyButton: 'Apply now'
  },
  Offers: {
    title: {
      generic: 'Offers',
      personal: 'Personal offers',
      promotions: 'Promotions'
    }
  },
  Otp: {
    incorrectOtp: 'Incorrect code, please try again',
    pleaseEnterCode: 'Please enter the code below',
    resend: 'RESEND',
    smsSent: 'An SMS with<br/>a code has been sent to<br/>xxxxxxxxx-{phoneNumber}'
  },
  PalCard: {
    btn: {
      cash: 'Get as cash',
      qr: 'Scan IutePay QR',
      shop: 'Use in shops'
    },
    title: 'Your spending limit'
  },
  PalPartnersPage: {
    title: 'Where can I use my spending limit?'
  },
  PartnerDetailsPage: {
    businessHours: 'Opening time',
    email: 'E-mail',
    phone: 'Phone',
    viewOnMap: 'View on map'
  },
  PartnersPage: {
    title: 'Our partners'
  },
  PaymentPartners: {
    description: {
      addiko: 'Addiko Bank',
      asa: 'ASA Banka',
      bosna: 'Bosna Bank International',
      intesa: 'Intesa Sanpaolo Bank',
      nlb: 'NLB Banka',
      privredna: 'Privredna Banka Sarajevo',
      raiffeisen: 'Raiffeisen Bank',
      sberbank: 'Sberbank',
      sparkasse: 'Sparkasse Bank',
      unicredit: 'UniCredit Bank',
      ziraat: 'Ziraat Bank'
    }
  },
  PaymentRedirectPage: {
    amount: 'Amount',
    cin: 'CIN',
    completeYourRepayment: 'Complete your repayment and you will see it instantly on your account through MyIute',
    copy: 'Copy',
    fiscalCode: 'Fiscal Code of IUTECredit',
    iban: 'Bank account',
    loanReferenceNumber: 'Loan reference number',
    makePayment: 'Make a repayment',
    openWebsite: 'Go to website',
    valueCopied: 'Copied {value}'
  },
  PreContractSendPage: {
    download: 'Download',
    downloadDescription: 'You can also download the pre-contract',
    email: 'E-mail',
    placeholder: 'Your e-mail',
    sendButton: 'Send to e-mail',
    title: 'Receive pre-contract on your email to review',
    wasSent: {
      message: 'Your pre-contract is now sent to the e-mail provided',
      title: 'Success'
    }
  },
  PrivacyPolicyPage: {
    title: 'Privacy policy'
  },
  Promotion: {
    showMore: 'Read more'
  },
  PromotionRedirectPage: {
    openWebsite: 'Go to website',
    title: 'Promotion'
  },
  QrScanPage: {
    cameraPermissionNotGranted: 'Camera permission not granted',
    description: 'Find a IutePay QR code in {action} to pay in parts',
    instruction: 'Look for a QR code with IutePay Logo, scan the code with your mobile phone camera. By scanning the QR code, you can start paying in parts in our partner store.',
    loading: 'Loading...',
    palPartnersLink: 'partner stores',
    title: 'Scan a IutePay QR',
    unsupportedQrCode: 'IutePay does not support this QR code'
  },
  RepaymentBalance: {
    yourRepaymentBalance: 'Your repayment balance'
  },
  SendDocumentForm: {
    closure: {
      send: 'Send the certificate',
      text: 'Get a certificate that confirms your loan balance is closed.',
      wasSent: {
        message: 'Your Closure Certificate is now sent to the e-mail provided',
        title: 'Success'
      }
    },
    email: 'E-mail',
    installments: {
      send: 'Send the schedule',
      text: 'Get the detailed repayment schedule that contains information about each repayment.',
      wasSent: {
        message: 'Your repayment schedule is now sent to the e-mail provided',
        title: 'Success'
      }
    },
    yourEmail: 'Your e-mail'
  },
  SignCardAgreementOtpPage: {
    signingAgreement: 'You are about to sign a card agreement:',
    warning: 'By signing the card agreement with the one-time-password sent to my verified phone number, I acknowledge and confirm to be legally bound by the foregoing terms.'
  },
  SignCardContractPage: {
    description: 'To proceed, send the contract to your e-mail for reviewing. After reading and agreeing with it you can sign it using your mobile device.',
    signContract: 'Sign the Mastercard contract',
    title: 'Sign Mastercard contract'
  },
  SignContractPage: {
    authenticationFailedError: 'Biometric authentication failed',
    description: 'To proceed, send the contract to your e-mail for reviewing. After reading and agreeing with it you can sign it using your mobile device.',
    download: 'Download',
    downloadDescription: 'You can also download the contract',
    email: 'Email',
    emailPlaceholder: 'Your e-mail',
    notAvailableError: {
      android: 'Biometry not available',
      default: 'Biometry not available',
      ios: 'Biometry (or passcode) not available'
    },
    reviewContract: 'Review the contract',
    send: 'Send to e-mail',
    sign: 'Sign',
    signContract: 'Sign the contract',
    signHintOtp: 'A confirmation code will be sent to your phone',
    signHintPki: 'Your phone will prompt you to authenticate yourself',
    title: 'Signing the contract',
    wasSent: {
      message: 'Your contract is now sent to the e-mail provided',
      title: 'Success'
    }
  },
  SignLoanApplicationOtpPage: {
    signingContract: 'You are about to sign a contract:',
    warning: 'By signing the loan agreement with the one-time-password sent to my verified phone number, I acknowledge and confirm to be legally bound by the foregoing terms.Please be aware that once the code has been entered, loan will become active.'
  },
  SignMastercardAgreement: {
    continueToSigning: 'Continue to signing',
    mastercard: 'Mastercard',
    signWithPhone: 'There is only one step left to start card delivery to you. Please review and sign Mastercard agreement and you will soon receive your card 😊'
  },
  SplashScreen: {
    connectingToServer: 'Connecting to server...'
  },
  SurveyPage: {
    answerIsRequired: 'Please select an answer',
    appreciation: 'We appreciate your help',
    backToApp: 'Back to using app',
    skip: 'Skip for Now',
    submit: 'Submit my Feedback',
    thankYou: 'Thank you!'
  },
  TopNav: {
    back: 'Back'
  },
  UpdateAccountPage: {
    accountUpdated: 'Account details updated',
    phone: 'Phone',
    phoneHint: 'Should start with 06 and be 9 or 10 digits long',
    saveChanges: 'Confirm',
    title: 'Update your phone number'
  },
  UploadPage: {
    documentPhoto1: 'Document photo 1',
    documentPhoto2: 'Document photo 2',
    idCardBack: 'ID-card back<br>Not necessary for passport',
    idCardFront: '<strong>ID-card front</strong><br>OR the <strong>passport</strong> page with the photo',
    takePhotosOfIdCard: 'Please take photos of your <strong>ID card</strong> or <strong>passport</strong> and upload them.',
    upload: 'Upload',
    uploadDocumentPhotos: 'Upload document photos',
    uploading: 'Uploading...'
  },
  WalletBalance: {
    newLoan: 'New loan',
    recentTransactions: 'Recents',
    showAllTransactions: 'Show all',
    withdraw: 'Payout',
    yourLoanBalance: 'Your wallet balance'
  },
  WalletTransactionDetailsPage: {
    amount: 'Amount',
    description: 'Description',
    time: 'Transaction time',
    title: 'Transaction details',
    today: 'Today',
    yesterday: 'Yesterday'
  },
  WalletTransactionsPage: {
    title: 'Transactions'
  },
  WalletWithdrawalPage: {
    atm: {
      amountInfo: 'You can withdraw {amount}.',
      subtitle: 'Find nearest Iute ATM',
      title: 'Get Cash from Iute ATM'
    },
    bank: {
      amountInfo: 'You can withdraw {amount}.',
      subtitle: 'Transfers available only to your accounts',
      title: 'Bank transfer'
    },
    conditions: 'All fees related to approved loan payout are included and at any time available on ',
    conditionsUrl: 'https://iutecredit.bg/about/conditions',
    easypay: {
      subtitle: 'Bulgarian payment provider',
      title: 'EasyPay'
    },
    existingMastercard: {
      amountInfo: 'You can withdraw {amount}.',
      title: 'Transfer money to your Mastercard'
    },
    mastercard: {
      title: 'Get IuteCredit Mastercard'
    },
    newMastercard: {
      amountInfo: 'You can withdraw {amount}.',
      title: 'Get IuteCredit Mastercard'
    },
    subtitle: 'Choose where to transfer your money.',
    title: 'Payout money'
  },
  WithdrawalAtmPage: {
    subtitle: 'Find the closest Iute ATM near you',
    title: 'Iute ATM cash payout'
  },
  WithdrawalBankTransferPage: {
    amount: 'Amount',
    bankAccount: 'Bank account of {name}',
    bankAccountHelp: '15 digits, for example, 250120000058984',
    bankAccountPlaceholder: '012345678901234',
    confirm: 'Confirm',
    continue: 'Continue',
    disclaimer: 'I hereby state and declare that the provided bank account number is mine and IuteCredit Bulgaria can use any mean deemed necessary to validate it',
    firstName: 'First name',
    lastName: 'Last name',
    subtitle: 'You are only allowed to transfer money to yourself',
    title: 'New bank transfer',
    yourLoanBalance: 'Your wallet balance: {amount}'
  },
  WithdrawalEasypayPage: {
    amount: 'Amount',
    confirm: 'Confirm',
    continue: 'Continue',
    subtitle: 'Easypay account must be associated with {name}, {pin}',
    title: 'Payout to Easypay',
    yourLoanBalance: 'Your wallet balance: {amount}'
  },
  WithdrawalEasypaySuccessPage: {
    done: 'Done',
    payoutRequestIsBeingProcess: 'Your request is being processed',
    sentTo: 'Initiated payout to {name}'
  },
  WithdrawalMastercardPage: {
    confirm: 'Confirm',
    disclaimer: '',
    signAgreement: 'Sign a card agreement',
    signAgreementDisclaimer: 'This card requires a new card agreement. Sign the new agreement to allow withdrawal.',
    subtitle: 'Select Mastercard for payout',
    title: 'Withdraw to Mastercard'
  },
  WithdrawalSuccessPage: {
    bankAccount: 'Bank account number',
    bankTransfer: 'Bank transfer',
    done: 'Done',
    payoutRequestIsBeingProcess: 'Your request is being processed',
    reference: 'Reference',
    sentTo: 'Initiated payout to {name}'
  },
  biometry: {
    cardAgreement: {
      cancel: 'Sign using SMS',
      description: 'By signing this agreement using your biometric credentials you acknowledge that no biometric data will be processed by us',
      subtitle: 'Sign using your biometric credential',
      title: 'Sign the card agreement'
    },
    createCertificate: {
      cancel: 'Sign using SMS',
      description: '',
      subtitle: 'Authenticate using your biometric credential',
      title: 'New IuteID'
    },
    login: {
      cancel: 'Not now',
      description: '',
      subtitle: 'Authenticate using your biometric credential',
      title: 'Log in'
    },
    loginSetup: {
      cancel: 'Not now',
      description: '',
      subtitle: 'Authenticate using your biometric credential',
      title: 'New IuteID'
    },
    signLoanContract: {
      cancel: 'Sign using SMS',
      description: 'By signing this agreement using your biometric credentials you acknowledge that no biometric data will be processed by us',
      subtitle: 'Sign using your biometric credential',
      title: 'Sign the loan contract'
    },
    updateAccount: {
      cancel: 'Not now',
      description: '',
      subtitle: 'Authenticate using your biometric credential',
      title: 'Confirm changing your phone number'
    }
  },
  errors: {
    alreadySigned: {
      content: 'Please go to the main screen',
      title: 'Contract is already signed'
    },
    application: {
      content: 'Please contact our customer support, +387 33 257 666 or +387 51 981 330',
      title: "Can't submit an application"
    },
    biometry: {
      content: 'Please try again',
      title: 'Biometric authentication failed'
    },
    les: {
      1: 'Please enter your phone number correctly and try again',
      2: 'Empty or invalid PEP consent',
      3: 'Empty or invalid GDPR consent',
      4: 'Empty or invalid loan amount',
      5: 'Empty or invalid loan period',
      6: 'Please provide a valid date of birth',
      7: 'Please enter your full name',
      8: 'Please enter your full last name',
      9: 'You have entered wrong PIN number. Please try again',
      10: 'Empty or invalid consent',
      101: 'Please enter your phone number correctly and try again',
      102: 'Please enter your phone number correctly and try again',
      103: 'Please enter your PIN number correctly and try again',
      104: 'Please provide a valid date of birth',
      105: 'Please provide a valid date of birth',
      106: 'Please provide a valid date of birth',
      107: 'Please enter your email address correctly',
      108: 'Loan period is too short',
      109: 'Loan period is too long',
      110: 'Invalid id card copy – front',
      111: 'Invalid id card copy – back',
      112: 'Invalid bank account number',
      113: 'Please enter your full name',
      114: 'Please enter your full last name',
      115: 'Invalid name',
      116: 'Please enter your patronymic correctly and try again',
      117: 'Invalid alternative contact name',
      118: 'Invalid loan amount',
      119: 'Invalid loan period',
      200: 'Loan product not found!',
      201: 'You have an existing application with us. Please use login to access your account and track your application',
      202: 'You have an account with us. Please use login to access your account and apply for a loan'
    },
    loginFailed: {
      content: "You do not have an account with us yet. Please go to homepage and use 'Apply for a loan' button.",
      title: 'Login failed'
    },
    newLoanNotAvailable: {
      content: 'Please contact our customer support, 13333',
      title: 'Sorry, new loan application is currently not available'
    },
    notAuthorized: {
      content: 'You do not have permission to view this loan/application. Please log-in.',
      title: 'Expired resource'
    },
    otpMaxRetriesExceeded: {
      content: 'Please try again.',
      title: 'Max number of incorrect attempts is reached.'
    },
    phoneMissed: {
      content: 'Please visit one of our branches to update your information to use our app',
      title: 'Login failed'
    },
    remainingTimeOver: {
      content: 'Please try again',
      title: 'Timeout reached'
    },
    signing: {
      content: 'Please contact our customer support, +387 33 257 666 or +387 51 981 330',
      title: "Can't sign an application"
    },
    technical: {
      content: 'Please try again later',
      title: 'Sorry, an error occurred'
    }
  },
  validation: {
    currency: 'Invalid amount for BAM',
    email: 'Please enter your email address correctly',
    iban: 'Please enter a valid IBAN',
    invalid: 'Invalid value',
    'local-bank-account': 'Please input correct bank account',
    max_date: 'Date must be less than today',
    max_value: 'Value must be less than {max}',
    min_value: 'Value must be greater than {min}',
    no_decimals: 'Must be a number',
    numeric: 'Only numbers are allowed',
    pin: 'Please fill-in your Identification number to proceed',
    pin_empty: 'Please fill-in your Identification number to proceed',
    pin_invalid: 'Please make sure you have entered your Personal Id number, not your loan reference number',
    regex: 'Invalid value',
    required: 'Required field',
    valid_date: 'Date is not valid'
  }
}
